var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5D6B72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7 7.5H18.6V2H5.4V7.5H4.3C2.474 7.5 1 8.974 1 10.8V17.4H5.4V21.8H18.6V17.4H23V10.8C23 8.974 21.526 7.5 19.7 7.5ZM7.6 4.2H16.4V7.5H7.6V4.2ZM16.4 19.6V17.4V15.2H7.6V19.6H16.4ZM18.6 15.2V13H5.4V15.2H3.2V10.8C3.2 10.195 3.695 9.7 4.3 9.7H19.7C20.305 9.7 20.8 10.195 20.8 10.8V15.2H18.6ZM17.5 11.35C17.5 10.7425 17.9925 10.25 18.6 10.25C19.2075 10.25 19.7 10.7425 19.7 11.35C19.7 11.9575 19.2075 12.45 18.6 12.45C17.9925 12.45 17.5 11.9575 17.5 11.35Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.ca5562f8.svg";
export { ForwardRef as ReactComponent };